export const getTranslationKeyForNextDayShipping = shortVersion =>
    shortVersion
        ? 'shipping-time-next-day-shipping-short'

    : 'shipping-time-next-day-shipping';
